import { render, staticRenderFns } from "./LoginBody.vue?vue&type=template&id=78e756b8&scoped=true&"
import script from "./LoginBody.vue?vue&type=script&lang=js&"
export * from "./LoginBody.vue?vue&type=script&lang=js&"
import style0 from "./LoginBody.vue?vue&type=style&index=0&id=78e756b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e756b8",
  null
  
)

export default component.exports